import { z } from "zod";
export const CommunitySettings = z.object({
    companyId: z.string().uuid(),
    communityEnabled: z.boolean(),
    autoPublishAfterSafety: z.boolean(),
    allowImages: z.boolean(),
    // Per-company Slack channels for announcements; null uses the deployment default.
    slackKudosChannelId: z.string().nullable().default(null),
    slackCommunityChannelId: z.string().nullable().default(null),
});
export const CommunityPreferences = z.object({
    userId: z.string().uuid(),
    companyId: z.string().uuid(),
    shareMoments: z.boolean(),
    sharePublicKudos: z.boolean(),
    avatarUrl: z.string().nullable().default(null),
});
export const CommunityCompany = z.object({
    id: z.string().uuid(),
    name: z.string().nullable(),
    imageUrl: z.string().nullable(),
    status: z.string().nullable(),
});
export const UpdateCommunitySettingsRequest = z.object({
    communityEnabled: z.boolean().optional(),
    autoPublishAfterSafety: z.boolean().optional(),
    allowImages: z.boolean().optional(),
    // Channel ids (C...); empty string or null clears back to the default.
    slackKudosChannelId: z.string().trim().max(30).nullable().optional(),
    slackCommunityChannelId: z.string().trim().max(30).nullable().optional(),
});
export const UpdateCommunityPreferencesRequest = z.object({
    shareMoments: z.boolean().optional(),
    sharePublicKudos: z.boolean().optional(),
});
export const UpdateCommunityPreferencesResponse = z.object({
    preferences: CommunityPreferences,
});
export const CommunityCapabilitiesResponse = z.object({
    canAccessAdmin: z.boolean(),
    /** Any ops dashboard seat (`resolveOpsCaller`), not only community admin. */
    canAccessOperations: z.boolean(),
    canModerateHealthOS: z.boolean(),
    canAdminCompanyCommunity: z.boolean(),
    roles: z.array(z.string()),
});
//# sourceMappingURL=settings.js.map